import type { RouteObject } from "react-router";

import { AccountPage, CheckoutCompletePage } from "@skilitics/designer-billing";

import { IntegrationsPage } from "./IntegrationsPage.tsx";
import { PersonalPage } from "./PersonalPage.tsx";
import { requireAdmin } from "./requireAdmin.tsx";
import { SettingsPage } from "./SettingsPage.tsx";
import { WorkspaceGeneralPage } from "./workspace/GeneralPage.tsx";
import { WorkspaceMembersPage } from "./workspace/MembersPage.tsx";

// Settings tab selection is based on id to avoid confusion between e.g.
// /settings and /settings/billing while still allowing the option of nested routes later.
const settingsChildRoutes: RouteObject[] = [
  { id: "settings-profile", index: true, Component: PersonalPage },
  { id: "settings-billing", path: "billing", Component: AccountPage },
  {
    path: "billing/complete",
    Component: CheckoutCompletePage,
  },
  {
    id: "settings-integrations",
    path: "integrations",
    Component: IntegrationsPage,
  },
  {
    id: "settings-workspace-general",
    path: "workspace",
    index: true,
    Component: WorkspaceGeneralPage,
  },
  {
    id: "settings-workspace-members",
    path: "workspace/members",
    Component: requireAdmin(WorkspaceMembersPage),
  },
] as const;

export type SettingsRouteId = (typeof settingsChildRoutes)[number]["id"];

export const settingsRoute: RouteObject = {
  path: "settings",
  Component: SettingsPage,
  children: [...settingsChildRoutes],
};
